import { createContext, useContext, useState } from "react";
import { useInACall, useRetainedCallObserver } from "./calling.ts";
import { useMedia, type Wired } from "./media.ts";

export type CallMediaSession = Wired & { arriveWith: (camera: boolean) => void };

const empty: CallMediaSession = {
  speakers: [],
  wired: false,
  mic: true,
  camera: false,
  toggleMic: () => undefined,
  toggleCamera: () => undefined,
  broke: null,
  arriveWith: () => undefined,
};
const MediaSession = createContext<CallMediaSession>(empty);

export function CallMediaProvider({ me, children }: { me: string | null; children: React.ReactNode }) {
  useRetainedCallObserver();
  const held = useInACall();
  const [withCamera, setWithCamera] = useState(false);
  const media = useMedia(me ? (held?.call ?? null) : null, me ?? "", withCamera);
  return (
    <MediaSession.Provider value={{ ...media, arriveWith: setWithCamera }}>{children}</MediaSession.Provider>
  );
}

export function useCallMedia(): CallMediaSession {
  return useContext(MediaSession);
}
